import { Component, OnInit } from '@angular/core';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { NotificationService } from '../../../../notification/shared/notification.service';
import { CUSTOM_DATE_FORMAT } from "../../../shared/datepicker/datepicker-format";
import { LectureCabService } from "../../shared/lecture-cab.service";

@Component({
  selector: 'app-lecture',
  templateUrl: './lecture.component.html',
  styleUrls: ['./lecture.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE], },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
  ]
})
export class LectureComponent implements OnInit {
  files = [];
  loading: boolean = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private lectureCabService: LectureCabService,
    private notificationService: NotificationService) { moment.locale('fr'); }

  ngOnInit() {
  }

  checkLecture() {
    if (this.files.length > 0) {
      this.loading = true;
      this.lectureCabService.checkLecture(this.files).subscribe(
        response => {
          this.lectureCabService.lecture = response;
          this.loading = false;
          this.router.navigate(['../check'], { relativeTo: this.route });
        }, error => this.loading = false
      )
    }
  }

  onFileSelected() {
    const inputNode: any = document.querySelector('#file');

    for (var i = 0; i < inputNode.files['length']; i++) {
      let file = inputNode.files[i]
      if (this.files.filter(el => el.name == file.name).length > 0) {
        this.notificationService.notif("le fichier " + file.name + " a déjà été importé", 'warn');
      } else {
        this.fileToDataURL(file).then((value) => {
          this.files.push({ name: file.name, fileURL: value })
        });
      }
    }
  }

  fileToDataURL(file_: File) {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.readAsDataURL(file_);
      reader.addEventListener(
        'load',
        function (event) {
          resolve(event.target.result);
        },
        false,
      );
    });
  }

  deleteFile(file) {
    this.files.splice(this.files.indexOf(file), 1);
  }
}
